import React from 'react';
import { getSelectOptionValue } from '../../services/selectOptions';

function resolveSelectValue(value) {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }
  return getSelectOptionValue(value, '');
}

export default function AppSelect({
  options = [],
  value,
  onChange,
  isDisabled,
  disabled,
  placeholder,
  inputId,
  className = '',
  name,
}) {
  const selectValue = resolveSelectValue(value);
  const isSelectDisabled = Boolean(isDisabled || disabled);

  const handleChange = (event) => {
    if (!onChange) {
      return;
    }
    const raw = event.target.value;
    const option = options.find((item) => String(item.value) === raw);
    if (option) {
      onChange(option);
      return;
    }
    onChange({ value: raw, label: raw });
  };

  const hasEmptyOption = options.some((item) => item.value === '');

  return (
    <select
      id={inputId}
      name={name}
      data-testid="react-select"
      className={`form-control app-native-select ${className}`.trim()}
      value={selectValue}
      onChange={handleChange}
      disabled={isSelectDisabled}
    >
      {placeholder && !hasEmptyOption ? (
        <option value="">{placeholder}</option>
      ) : null}
      {options.map((item, index) => (
        <option key={`${String(item.value)}-${index}`} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
}
